import { render } from "./Sidemenu.vue?vue&type=template&id=437073aa&scoped=true"
import script from "./Sidemenu.vue?vue&type=script&lang=js"
export * from "./Sidemenu.vue?vue&type=script&lang=js"

import "./Sidemenu.vue?vue&type=style&index=0&id=437073aa&lang=scss&scoped=true"
import "./Sidemenu.vue?vue&type=style&index=1&id=437073aa&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-437073aa"]])

export default __exports__